module.exports = __webpack_public_path__ + "static/media/loginLogo.9e918efa.png";